'use client';

import { useSyncExternalStore } from 'react';

export function useFundingPageActive(): boolean {
  return useSyncExternalStore(subscribe, isVisible, () => false);
}

function subscribe(listener: () => void): () => void {
  document.addEventListener('visibilitychange', listener);
  return () => document.removeEventListener('visibilitychange', listener);
}

function isVisible(): boolean {
  return document.visibilityState === 'visible';
}
